/**
 * 휴지통 캠페인 «읽기 전용 전체 보기» — 2026-10-23 사용자 «읽기 전용은 유지하되, 휴지통에서도 이전처럼 전체 내용을 그대로».
 *
 * 휴지통에서 캠페인을 열면 평소 상세 화면을 `/campaign/:id?trash=1` 로 연다.
 *  - 읽기(GET)에는 `x-trash-view: 1` 을 붙인다 — 서버가 그 요청에서만 휴지통 필터를 건너뛴다(권한 표 「휴지통」).
 *  - 쓰기(POST·PUT·PATCH·DELETE)는 보내지 않는다 — 화면 어디서 저장을 눌러도 여기서 멈춘다(서버도 막는다).
 * 머리글은 그 캠페인 id 가 든 주소에만 붙인다 — 왼쪽 캠페인 목록 같은 다른 읽기에 휴지통 것이 섞이지 않게.
 */
export const TRASH_VIEW_HEADER = 'x-trash-view';
export const TRASH_VIEW_BLOCKED = '휴지통에 있는 캠페인은 읽기 전용입니다. 고치려면 먼저 되살려 주세요.';

/** 지금 화면이 휴지통 읽기 전용 보기면 그 캠페인 id, 아니면 null */
export function trashViewCampaignId(loc = typeof window !== 'undefined' ? window.location : null) {
  if (!loc) return null;
  const m = /^\/campaign\/([^/?#]+)\/?$/.exec(loc.pathname || '');
  if (!m || new URLSearchParams(loc.search || '').get('trash') !== '1') return null;
  return decodeURIComponent(m[1]);
}

/** axios 요청 가로채기 — 휴지통 보기면 읽기에 머리글을 붙이고 쓰기는 거절한다 */
export function applyTrashView(config, loc) {
  const id = trashViewCampaignId(loc);
  if (!id) return config;
  const method = String(config.method || 'get').toLowerCase();
  if (method !== 'get' && method !== 'head') {
    const err = new Error(TRASH_VIEW_BLOCKED);
    err.trashViewBlocked = true;
    err.config = config;
    err.response = { status: 403, data: { message: TRASH_VIEW_BLOCKED } };
    throw err;
  }
  const url = `${config.url || ''}?${JSON.stringify(config.params || {})}`;
  if (!url.includes(id)) return config;
  // axios 1.x 는 AxiosHeaders(set 이 있음), 시험·옛 호출은 일반 객체
  if (config.headers && typeof config.headers.set === 'function') config.headers.set(TRASH_VIEW_HEADER, '1');
  else config.headers = { ...(config.headers || {}), [TRASH_VIEW_HEADER]: '1' };
  return config;
}
